import { render, staticRenderFns } from "./Enrollsuper.vue?vue&type=template&id=6d97c703&scoped=true"
import script from "./Enrollsuper.vue?vue&type=script&lang=js"
export * from "./Enrollsuper.vue?vue&type=script&lang=js"
import style0 from "./Enrollsuper.vue?vue&type=style&index=0&id=6d97c703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97c703",
  null
  
)

export default component.exports